export const UserStrings = {
  users: 'Users',
  loadingUserList: 'Loading user list...',
  userListError: 'Cannot fetch user list',
}
